import { render, staticRenderFns } from "./BudgetDeepFoundationList.vue?vue&type=template&id=2027f950&scoped=true"
import script from "./BudgetDeepFoundationList.vue?vue&type=script&lang=js"
export * from "./BudgetDeepFoundationList.vue?vue&type=script&lang=js"
import style0 from "./BudgetDeepFoundationList.vue?vue&type=style&index=0&id=2027f950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2027f950",
  null
  
)

export default component.exports